"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@honeybadger-io/react");
const browser_1 = __importDefault(require("@hyperdx/browser"));
const react_2 = require("react");
const react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3");
const react_gtm_module_1 = __importDefault(require("react-gtm-module"));
const react_toastify_1 = require("react-toastify");
const components_1 = require("components");
const config_1 = require("config");
const AnalyticsContext_1 = require("../../context/AnalyticsContext");
const Routes_1 = __importDefault(require("./Routes"));
function App() {
    const { setAppName } = (0, react_2.useContext)(AnalyticsContext_1.AnalyticsContext);
    if (process.env.REACT_APP_GTM_ID) {
        react_gtm_module_1.default.initialize({
            gtmId: process.env.REACT_APP_GTM_ID,
            events: {
                conversion: 'conversion',
            },
        });
    }
    const testEnv = (0, config_1.getTestEnv)();
    const initHoneybadger = () => {
        return react_1.Honeybadger.configure({
            apiKey: process.env.REACT_APP_HONEYBADGER_API_KEY,
            environment: process.env.REACT_APP_BUILD_ENV,
        });
    };
    const honeybadger = initHoneybadger();
    const init = () => {
        let checkRegEx = null;
        if (testEnv) {
            checkRegEx = [/api.qa.alphaeontest.com/i];
        }
        else {
            checkRegEx = [/api.alphaeon.com/i];
        }
        if (!testEnv) {
            browser_1.default.init({
                apiKey: config_1.REACT_APP_HYPERDX,
                service: 'credit-portal',
                tracePropagationTargets: checkRegEx, // Set to link traces from frontend to backend requests
                consoleCapture: true, // Capture console logs (default false)
                advancedNetworkCapture: true, // Capture full HTTP request/response headers and bodies (default false)
            });
        }
        // AnalyticsContext
        if (setAppName) {
            setAppName('credit-portal');
        }
        browser_1.default.setGlobalAttributes({
            site_environment: testEnv ? 'DEV' : 'PROD',
            site_portal: 'credit-portal',
            userAgent: window.navigator.userAgent,
        });
    };
    (0, react_2.useEffect)(() => {
        init();
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(AnalyticsContext_1.AnalyticsProvider, { appName: "credit-portal", children: (0, jsx_runtime_1.jsxs)(react_1.HoneybadgerErrorBoundary, { honeybadger: honeybadger, children: [(0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { closeButton: components_1.ToastDismissButton }), (0, jsx_runtime_1.jsxs)(react_google_recaptcha_v3_1.GoogleReCaptchaProvider, { reCaptchaKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY, scriptProps: { async: true, defer: true, appendTo: 'body' }, children: [testEnv && (0, jsx_runtime_1.jsx)(components_1.TestEnvironmentBanner, { env: testEnv }), (0, jsx_runtime_1.jsx)(Routes_1.default, {}), (0, jsx_runtime_1.jsx)(components_1.TooZoom, {}), (0, jsx_runtime_1.jsx)(components_1.VersionChangeReporter, { redirectURL: config_1.CREDIT_PORTAL_URL })] })] }) }) }));
}
exports.default = App;
